import React, { useState, useEffect } from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import * as css from './Youtube.module.scss';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

export type YoutubeProps = {
    // id of the video or playlist
    id: string;

    title: string;

    time?: number;

    // Use true when your ID be from a playlist
    isPlaylist?: boolean;

    // The ids for playlists did not bring the cover in a pattern to render
    // so you'll need pick up a video from the playlist (or in fact, whatever id)
    // and use to render the cover.
    //
    // There's a programmatic way to get the cover from YouTube API v3
    // but the aim of this component is do not make any another call
    // and reduce requests and bandwidth usage as much as possibe
    playlistCoverId?: string;
};

/*** @see https://github.com/ibrahimcesar/react-lite-youtube-embed */
export function Youtube({ id, title, time, isPlaylist = false, playlistCoverId }: YoutubeProps) {
    const params: string[] = ['rel=0'];
    if (Number.isInteger(time)) params.push(`t=${time}`);

    // If the highgest quality poster image from the YouTube CDN
    // is a known fallback (because it may not exist for some reason),
    // we'll switch to a lower quality image that should always be available.
    const [isFallback, setIsFallback] = useState(false);
    useEffect(() => {
        const img = new Image();

        img.onerror = () => setIsFallback(true);
        // The fallback image is 120x90, so we'll check if the image is smaller than that with some margin
        img.onload = () => setIsFallback(img.naturalWidth <= 130 && img.naturalHeight <= 100);

        img.src = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
    }, [id]);

    return (
        <div className={css.root}>
            <LiteYouTubeEmbed
                cookie
                adNetwork={false}
                id={id}
                // any params you want to pass to the URL, assume we already had '&' and pass your parameters string
                params={params.join('&')}
                playlist={isPlaylist}
                playlistCoverId={playlistCoverId}
                // Defines the image size to call on first render as poster image.
                // Possible values are:
                //  "default"
                //  "mqdefault"
                //  "hqdefault"
                //  "sddefault"
                //  "maxresdefault"
                //
                //  Default value for this prop is "hqdefault".
                //  Please be aware that "sddefault" and "maxresdefault", high resolution images
                //  are not always avaialble for every video.
                //
                //  See: https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
                poster={isFallback ? 'hqdefault' : 'maxresdefault'}
                title={title}
            />
        </div>
    );
}
